/* Temporary workaround for SLSB-4698. Remove after the app fix is deployed. */
(() => {
  const checkoutSelector = [
    '[name="checkout"]',
    '[href="/checkout"]',
    'form[action="/checkout"] input[type="submit"]',
    '.checkout_button',
    '.Button--modal_checkout',
  ].join(',');

  const unlockShippingCheckout = (root) => {
    const shippingTab = root?.getElementById('shipping');

    // Never bypass Pickup or Delivery validation.
    if (shippingTab?.getAttribute('aria-selected') !== 'true') return;

    window.mwDeliveryDateCheckoutReady = true;

    document.querySelectorAll(checkoutSelector).forEach((button) => {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    });
  };

  const attach = (widget) => {
    if (widget.dataset.shippingCheckoutHotfix === 'true') return;

    const root = widget.shadowRoot;

    if (!root) {
      window.setTimeout(() => attach(widget), 100);
      return;
    }

    widget.dataset.shippingCheckoutHotfix = 'true';

    root.addEventListener('click', (event) => {
      const selectedShipping = event
        .composedPath()
        .some(
          (node) =>
            node instanceof HTMLElement && node.id === 'shipping',
        );

      if (!selectedShipping) return;

      // Cover the asynchronous tab transition and cart-attribute cleanup.
      [0, 100, 300, 750, 1500].forEach((delay) => {
        window.setTimeout(() => unlockShippingCheckout(root), delay);
      });
    });

    new MutationObserver(() => unlockShippingCheckout(root)).observe(root, {
      attributes: true,
      attributeFilter: ['aria-selected'],
      subtree: true,
    });

    unlockShippingCheckout(root);
  };

  let scheduled = false;

  const scan = () => {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;

      document.querySelectorAll('mw-delivery-date').forEach(attach);

      // Also handles checkout buttons replaced by an Ajax cart refresh.
      const root = document.querySelector('mw-delivery-date')?.shadowRoot;
      unlockShippingCheckout(root);
    });
  };

  scan();

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();